import createStorageAtomFactory from '../factories/storage.js';
const getCacheAtom = ({ storage, key }) => {
    const createStorageAtom = createStorageAtomFactory({ storage });
    return createStorageAtom({ key });
};
const enhanceAtom = (params) => {
    const { atom, logger } = params;
    const cacheAtom = getCacheAtom(params);
    if (!atom.hasOwnProperty('set')) {
        logger.warn('Atom does not have a "set" method, cache will last only until the app is restarted');
    }
    let hasCache = false;
    const setCache = async (fresh) => {
        try {
            await cacheAtom.set(fresh);
            hasCache = true;
        }
        catch (error) {
            logger.warn('Failed to write to cache atom', error);
        }
    };
    const readCache = async () => {
        try {
            return (await cacheAtom.get());
        }
        catch (error) {
            logger.warn('Failed to read from cache atom, returning fresh', error);
            return readFresh();
        }
    };
    const readFresh = async () => {
        const fresh = await atom.get();
        await setCache(fresh);
        return fresh;
    };
    const set = async (value) => {
        try {
            await atom.set(value);
        }
        catch (error) {
            logger.warn('Failed to write to atom, is it a readonly atom? Clearing cache...', error);
        }
        finally {
            hasCache = false;
        }
    };
    const get = async () => {
        return hasCache ? readCache() : readFresh();
    };
    const reset = async () => {
        try {
            await atom.reset();
            await cacheAtom.reset();
        }
        catch (error) {
            logger.warn('Failed to write to atom, is it a readonly atom? Clearing cache...', error);
        }
        finally {
            hasCache = false;
        }
    };
    return { ...atom, get, set, reset };
};
const withStorageCache = (params) => {
    return enhanceAtom(params);
};
export default withStorageCache;
